/* This file is autogenerated, see readme.md for instructions */
import TextStyleSvgIcon from '@bloomreach/banana-theme/icons/text-style.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const TextStyleIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <TextStyleSvgIcon />
    </Icon>
  );
});

TextStyleIcon.displayName = 'TextStyleIcon';

export default TextStyleIcon;
